import { PolicyValidator, Policy, checkLicense } from '../policy.interface';

const appPolicy: PolicyValidator = {
    validate: (policy: Policy) => {
        return checkLicense(policy, 'Department_license');
    }
};

export default appPolicy;
